import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { REGCONFIG_CONTROL } from 'src/app/models/common';
import { GridApi } from 'ag-grid-community';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationConfigurationAddfieldComponent } from './registration-configuration-addfield/registration-configuration-addfield.component';
import { RegistrationConfigurationReorderComponent } from './registration-configuration-reorder/registration-configuration-reorder.component';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-registration-configuration-modal',
  templateUrl: './registration-configuration-modal.component.html',
  styleUrls: ['./registration-configuration-modal.component.scss']
})
export class RegistrationConfigurationModalComponent implements OnInit ,IDeactivateComponent{
  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  public selectData: any[] = [];
  columnDefs;
  gridApi: GridApi;
  selectedRow;
  selectedRecord: REGCONFIG_CONTROL;
  rowData: REGCONFIG_CONTROL[] = [];
  StaticrowData: REGCONFIG_CONTROL[] = []; 
  gridOptions;
  context: any;
  cancelBtn: string = "Cancel";
  frameworkComponents: any;
  loadTeam: boolean = false;
  TempOperations:any=[];
  operations: any;
  StaticTempOperations:any=[];
  ModuleId: any;
  SCREEN_ID:any;
  ScreenName: any;
  RequiredSettings: boolean = true;
  RequiredSendBackRowData: boolean = true;
  IsFormData: boolean = false;
  constructor(    
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    public commonService: CommonService
  ) {

    this.columnDefs = [
      {
        "headerName": "Field Name",
        "field": "LABEL",
        tooltipField:"LABEL"
      }, {
        "headerName": "Type",
        "field": "CONTROLTYPE",
        tooltipField:"CONTROLTYPE"
      },
      {
        "headerName": "Status",
        "field": "STATEVALUE",
        tooltipField:"STATEVALUE"
      },
      {
        "headerName": "Mandatory",
        "field": "IS_MANDATORYStr",
        tooltipField:"IS_MANDATORYStr"
      },
      {
        headerName: "Actions",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ]

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };
  }
  ngOnInit() {
    if (this.Content.content && this.Content.content.id !=null && this.Content.content.id!=undefined) {
      this.ModuleId = this.Content.content.Moduleid;
      this.SCREEN_ID =this.Content.content.id;
      this.ScreenName=this.Content.content.ScreenName;
    }
    this.TempOperations = [
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];
    
    this.StaticTempOperations = [
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];   
    this.getScreenData();   
    
  }

  getScreenData() {
      ;
    if (this.Content.content && this.Content.content.id !=null && this.Content.content.id!=undefined) { // Edit mode  this.Content.content && this.Content.content.id &&
     
      this.summaryService.getRegistrationConfig(this.Content.content.id).subscribe((result) => {
        this.rowData = result;          
        this.StaticrowData = this.getGridData(this.rowData);       
         ;
        this.loadTeam = false;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click();
        }, 300);        
      })
    } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'View') { //View mode
       ;
      this.cancelBtn = "Close";
      this.summaryService.getRegistrationConfig(this.Content.content.id).subscribe((result) => {
        this.rowData = result; 
         this.StaticrowData = this.getGridData(this.rowData);  
        this.loadTeam = false;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click(); 
        }, 300);        
      })
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {

  }

  edit(data) {
      ;
    let row = data;
    let screenId = this['self'].SCREEN_ID;
    const modalRefAdd = this['self'].modalService.open(RegistrationConfigurationAddfieldComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,

    });
    modalRefAdd.componentInstance.Content = {
      heading: 'Edit',
      content: { id: screenId, operation: "Edit", Data: row },
      rowData: _.cloneDeep(this['self'].rowData)
    }

    modalRefAdd.result.then(result => {
       ;
      this['self'].StaticrowData.forEach((item) => {
        if (item.ID == result.ID) {
           ;
          item.STATE = result.STATE;
          item.STATEVALUE = result.STATEVALUE;
          item.CONTROL = result.CONTROL;
          item.ID = result.ID;
          item.IS_MANDATORY = result.IS_MANDATORY;
          item.RECORD_STATE = item.STATEVALUE == "Active" ? 1 : 0;
          item.IS_MANDATORYStr = result.IS_MANDATORYStr;
          item.CONTROLTYPE = result.CONTROLTYPE;
          item.SERIAL_NO = result.SERIAL_NO;
          item.SCREEN_ID = result.SCREEN_ID;
          item.IsAllowMultipleFiles = result.ISALLOWMULTIPLEFILES;
          item.ISALLOWMULTIPLEFILES = result.ISALLOWMULTIPLEFILES;
          item.GROUP_VALUES = result.GROUP_VALUES;
          item.GROUP_VALUES_LIST = result.GROUP_VALUES_LIST;
          item.SUBFIELDNAME = result.SUBFIELDNAME;
          item.LABEL = result.LABEL;
          item.DATEFORMATE = result.DATEFORMATE;
          item.IsActive = result.IsActive;
          item.MAXCHARACTERLENGTH = result.MAXCHARACTERLENGTH;
          item.PURPOSE = result.PURPOSE;
        }
      });

      this['self'].StaticrowData = this['self'].getGridData(this['self'].StaticrowData);
      this['self'].loadTeam = false;
      this.IsFormData= true;
      setTimeout(() => {
        this['self'].loadTeam = true;
        document.body.click();
      }, 100);
    })
  }
  delete(data) {
    let row = data;
    const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false
    })
    modalRef.componentInstance.Content = {
      heading: 'Delete',
      custommessage: 'Are you sure you want to delete the Field ' + row.LABEL + ' ?',
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }
    modalRef.result.then(result => {
       
      if (result == "okclick") {
        if (row.ROWSTATE != "Add") {
          this['self'].summaryService.checkRegControlReference(row.ID).subscribe((res) => {
             
            if (res["Status"]==2) {
            //    
              this['self'].commonService.ValidationBanner("You cannot delete this field as it is associated with a registration");
            }
            else {
              let eleindex = 0;
              this['self'].rowData.forEach((item, index) => {
                if (item.ID == row.ID) {
                  this['self'].loadTeam = false;
                  eleindex = index;
                  this['self'].rowData.splice(index, 1);
                  setTimeout(() => {
                    this['self'].loadTeam = true;
                    document.body.click();
                  }, 100);
                }
              });

              this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData);
              this['self'].loadTeam = false;
              setTimeout(() => {
                this['self'].loadTeam = true;
                document.body.click();
              }, 100);
            }
          });
        }
        else {
          let eleindex = 0;
          this['self'].rowData.forEach((item, index) => {
            if (item.ID == row.ID) {
              eleindex = index;
              this['self'].rowData.splice(index, 1);

            }
          });
          this['self'].StaticrowData = this['self'].getGridData(this['self'].rowData);
          this['self'].loadTeam = false;
          this.IsFormData= true;
          setTimeout(() => {
            this['self'].loadTeam = true;
            document.body.click();
          }, 100);
        }
      }
    });
  }

  addRow() {
    let modalRefAdd = this.modalService.open(RegistrationConfigurationAddfieldComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRefAdd.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", operation: "Add" },
      rowData: this.rowData
    }
     
    modalRefAdd.result.then(result => {
      this.loadTeam = false;
      let TempList = [];
       ;
      result.RECORD_STATE = result.STATEVALUE == "Active" ? 1 : 0;
      if (this.rowData == undefined && this.rowData == null) {
        this.rowData = [];
      }
      if (this.StaticrowData == undefined && this.StaticrowData == null) {
        this.StaticrowData = [];
      }
      TempList.push(result);
      this.rowData = TempList.concat(this.rowData);
      let finalList = TempList.concat(this.StaticrowData);
      this.StaticrowData = this.getGridData(finalList);
      this.loadTeam = false;
      this.IsFormData= true;
        setTimeout(() => {
          this.loadTeam = true;
          document.body.click();
        }, 300);     
    })
  }

  addcontrol(): any {
    this.modalRef.dismiss();
  }

  getGridData(Data: any): any {
    let FilterData = [];
      Data.forEach((item) => {
        if (item.IS_STATIC) {
          
          item.CONTROLTYPE = this.getcontroltype(item.CONTROL);
          item.IS_MANDATORYStr = item.IS_MANDATORY == true ? "Yes" : "No";
        item.STATEVALUE = item.RECORD_STATE == 1 ? "Active" : "Inactive";
          item["Operations"] = this.TempOperations.map(operation => {
            return operation && operation.id === 'add' ? 
            { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : 
            { name: operation.name, callback: this[operation.id], self: this }
          });
          FilterData.push(item);
        }
        if (item.IS_STATIC != true) {
        
          item.CONTROLTYPE = this.getcontroltype(item.CONTROL);
          item.IS_MANDATORYStr = item.IS_MANDATORY == true ? "Yes" : "No";
          item.STATEVALUE = item.RECORD_STATE == 1 ? "Active" : "Inactive";
          item["Operations"] = this.TempOperations.map(operation => {
            return operation && operation.id === 'add' ? 
            { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : 
            { name: operation.name, callback: this[operation.id], self: this }
          });
          FilterData.push(item);
        }
        if(this.Content.heading == "View")
        {
         item["Operations"]=[];
        }
      });
      FilterData.forEach((item) => {
         if(item.PARENT_FIELD_CODE!=null && item.PARENT_FIELD_CODE!=undefined &&  item.PARENT_FIELD_CODE!="")
         {
            let ParentRecord= FilterData.filter((citem)=>{
             return citem.FIELD_CODE==item.PARENT_FIELD_CODE
            })[0];
            if(ParentRecord!=null && ParentRecord!=undefined && ParentRecord.IS_DISPLAY == 0)
            {
              item["Operations"]=[];
            }
         }
         if(item.IS_EDITABLE == false && item.IS_NAME_EDITABLE == false)
          {
            item["Operations"]=[];
          }
      });
      return FilterData;
     }

  getcontroltype(ctype: any): string {
    ctype = parseInt(ctype);
    var controltype = "";
    switch (ctype) {
      case 1:
        controltype = "Alpha numeric Text";
        break;
      case 2:
        controltype = "Alphabet Text";
        break;
      case 3:
        controltype = "Number";
        break;
      case 4:
        controltype = "Single select dropdown";
        break;
      case 5:
        controltype = "Date";
        break;
      case 6:
        controltype = "Checkbox";
        break;
      case 7:
        controltype = "Radio Buttons";
        break;
      case 8:
        controltype = "Upload";
        break;
      case 9:
        controltype = "Label";
        break;
      case 10:
        controltype = "Multi-select dropdown";
        break;
  case 11:
        controltype = "Text area";
        break;
      default:

        break;
    }


    return controltype;
  }

  onOperationClick(operation) {
    if(operation!= null && operation!= undefined && operation!= "")
      {
        operation.callback();
      }
  }

  Reorder() {   
    let modalRefAdd = this.modalService.open(RegistrationConfigurationReorderComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRefAdd.componentInstance.Content = {
      heading: 'Reorder',
      //content: { operation: "Edit", Data: this.DynamicrowData },
      content: { operation: "Edit", Data: this.StaticrowData },
    }
    modalRefAdd.result.then(result => {
      this.rowData = result;
      this.StaticrowData = this.getGridData(this.rowData);  
      
      this.loadTeam = false;
      this.IsFormData= true;
      setTimeout(() => {
        this.loadTeam = true;
        document.body.click();
      }, 100);
    })
  }

  save() {
      let formData = { "MODULE_ID":this.ModuleId ,"SCREEN_ID":this.SCREEN_ID  };
      let rowdata = [];
      this.StaticrowData.forEach((item) => {
        item["Operations"] = null;
        rowdata.push(item);
      });     

      let IsDisplayExits = this.StaticrowData.filter((item) => {
        return (item.IS_DISPLAY != 0)
      })[0];
      let IsActiveExits = this.StaticrowData.filter((item:any) => {
        return (item.RECORD_STATE == 1)
      })[0];

      if ((IsDisplayExits != null && IsDisplayExits != undefined) ||(IsActiveExits != null && IsActiveExits != undefined)) {

        formData["lstRegConfs"] = rowdata;  
        if (this.Content.content && this.Content.content.id) {
          this.summaryService.saveRegistrationConfig(formData).subscribe(result => {
            if (result.Status === 0) {
              this.commonService.SuccessBanner("Screen '" + this.ScreenName + "' updated successfully");              
              this.modalRef.close();
            }
            else {
              this.commonService.ValidationBanner(result.Message);              
            }
          })
        }
      }
      else {
        this.commonService.ValidationBanner("At-least one static/flex field should be available in active/display state to save the details");
      }
   // }
  }
  canExit() {
    if (this.IsFormData) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
  close(){
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });
  }
}
